import React from 'react';
import $ from 'jquery';
import Plotly from 'plotly.js/dist/plotly.min.js';
import {GetParams, MWBaseURL} from './../Utilities.js'
import {createApiClient} from "../api/ApiClient";

class Graph extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			date: null,
			start: null,
			end: null,
			firm: null,
			acct: null,
			sybl: null,
			tag: null,

			posVSmv: "S",

			startTS: null,
			endTS: null,

			extendGraph: false,
			needToUpdate: false,
			needToResize: false,
			updateCount: 0,

			graphIsLoading: false,
			graphIsLoaded: false
		};

		this.timeseries = []
		this.timeseriesPos = []

		this.graphLayout = {
			hovermode: "x",
			showlegend: false,
			xaxis: {
				rangemode: "tozero"
			},
			yaxis: {
				title: "Net PNL",
				fixedrange: true,
				tickformat: '$,~s'
			},
			legend: {"orientation": "h"},
			margin: {
				l: 70,
				r: 70,
				b: 50,
				t: 0,
				pad: 0
			}
		}

		this.graphConfig = {
			displaylogo: false,
			scrollZoom: true,
			responsive: true,
			displayModeBar: false
		}
		this.controller = new AbortController()
	}

	static getDerivedStateFromProps(props, state) {
		if((state.date && props.date && state.date !== props.date)
			|| state.firm !== props.firm || state.acct !== props.acct || (state.sybl && props.sybl && state.sybl.toString() !== props.sybl.toString())
			|| state.height !== props.height){
			return {...props, needToUpdate: true}
		}else if(state.start !== props.start || state.end !== props.end){
			return {...props, needToResize: true}
		}else if(state.updateCount !== props.updateCount){//if anything else changes than those take precedence
			//Every 15 min, full reload. As an update is called every 15 sec, 60 updates is 15 min
			if(props.updateCount % 60 === 0){
				return {...props, needToUpdate: true}
			}else{
				return {...props, extendGraph: true}
			}
		}
		return {...props};
	}

	componentDidUpdate(props, state){
		if(this.state.extendGraph){
			let self = this
			this.setState({extendGraph: false}, function(){
				if(!self.graphElementExists()){//this should be debugged as this error should never actually appear
					return;
				}
				self.setState({graphIsLoaded: false})
				self.loadGraph(true && self.timeseries.length > 0)// If there is not already data than it can't be an extention
			})
		}else if(this.state.needToUpdate){
			let self = this
			this.setState({needToUpdate: false}, function(){
				if(!self.graphElementExists()){//this should be debugged as this error should never actually appear
					return;
				}
				//Plotly.purge('graph');
				self.setState({graphIsLoaded: false})
				self.loadGraph()
			})
		}else if(this.state.needToResize){
			let self = this
			this.setState({needToResize: false}, function(){
				if(self.state.graphIsLoaded){
					self.resizeGraph()
				}
			})
		}
	}

	componentDidMount() {
		this.loadGraph()
	}

	componentWillUnmount(){
		this.setState({graphIsLoading: false})
		this.setState({graphIsLoaded: false})
		this.controller.abort();
	}

	resizeGraph = () => {

		/*Plotly.relayout( 'graph', {//for switching between days
			'xaxis.autorange': true,
			'yaxis.autorange': true,
			'relayedout': true
		});*/

		let self = this
		let resizeCoord = {
			'relayedout': true
		}

		function pad(number) {
			if (number < 10) {
				return '0' + number;
			}
			return number;
		}

		function DateToString(d) {
			return d.getFullYear() +
			'-' + pad(d.getMonth() + 1) +
			'-' + pad(d.getDate()) +
			' ' + pad(d.getHours()) +
			':' + pad(d.getMinutes()) +
			':' + pad(d.getSeconds()) +
			'.' + (d.getMilliseconds() / 1000).toFixed(3).slice(2, 5);
		};

		let ts = new Date(new Date(self.state.startTS).setMinutes(new Date(self.state.startTS).getMinutes() - 1))
		if(this.state.start && this.state.start >= DateToString(ts)){
			resizeCoord["xaxis.range[0]"] = this.state.start
		}else{
			resizeCoord["xaxis.range[0]"] = DateToString(ts)
		}
		let te = new Date(new Date(self.state.endTS).setMinutes(new Date(self.state.endTS).getMinutes() + 1))
		if(this.state.end && this.state.end <= DateToString(te)){
			resizeCoord["xaxis.range[1]"] = this.state.end
		}else{
			resizeCoord["xaxis.range[1]"] = DateToString(te)
		}
		
		//fix x axis
		let obj = {}
		if(this.state.start && this.state.start < self.state.startTS){
			obj["selectedx0"] = null
		}
		if(this.state.end && this.state.end > self.state.endTS){
			obj["selectedx1"] = null
		}
		if("selectedx0" in obj || "selectedx1" in obj){
			self.state.refilter(obj)
		}

		if(!this.state.start && !this.state.end){
			resizeCoord["xaxis.autorange"] = true
		}

		let relevantData = this.timeseries;

		if(this.state.start){
			relevantData = relevantData.filter(obj => obj.timestamp > self.state.start)
			let tempIdx = this.timeseries.slice().reverse().findIndex(x => x.timestamp < self.state.start)
			let prevIdx = this.timeseries.length - tempIdx - 1
			if(tempIdx !== -1 && prevIdx >= 0){
				relevantData.unshift(this.timeseries[prevIdx])
			}
		}
		if(this.state.end){
			relevantData = relevantData.filter(obj => obj.timestamp < self.state.end)
			let nextIdx = this.timeseries.findIndex(x => x.timestamp > self.state.end)
			if(nextIdx !== -1){
				relevantData.push(this.timeseries[nextIdx])
			}
		}

		if(relevantData.length <= 0){
			console.log("No data for resizing?")
			return
		}
		if("pnl" in relevantData[0]){
			let pnlArr = relevantData.map(x => x.pnl)
			let minpnl = Math.min(...pnlArr)
			let maxpnl = Math.max(...pnlArr)
			resizeCoord["yaxis.range[0]"] = minpnl - (maxpnl - minpnl) * 0.05
			resizeCoord["yaxis.range[1]"] = maxpnl + (maxpnl - minpnl) * 0.05
		}
		if(this.timeseriesPos.length > 0){
			let relevantPosData = this.timeseriesPos
			if(this.state.start){
				relevantPosData = relevantPosData.filter(obj => obj.timestamp > self.state.start)
				let tempIdx = this.timeseriesPos.slice().reverse().findIndex(x => x.timestamp < self.state.start)
				let prevIdx = this.timeseriesPos.length - tempIdx - 1
				if(tempIdx !== -1 && prevIdx >= 0){
					relevantPosData.unshift(this.timeseriesPos[prevIdx])
				}
			}
			if(this.state.end){
				relevantPosData = relevantPosData.filter(obj => obj.timestamp < self.state.end)
				let nextIdx = this.timeseriesPos.findIndex(x => x.timestamp > self.state.end)
				if(nextIdx !== -1){
					relevantPosData.push(this.timeseriesPos[nextIdx])
				}
			}
			let posArr = []
			if(self.state.posVSmv === "S"){
				posArr = relevantPosData.map(x => x.position)
			}else if(self.state.posVSmv === "MV"){
				posArr = relevantPosData.map(x => x.position*x.price)
			}
			let minpos = Math.min(...posArr)
			let maxpos = Math.max(...posArr)
			resizeCoord["yaxis2.range[0]"] = minpos - (maxpos - minpos) * 0.05
			resizeCoord["yaxis2.range[1]"] = maxpos + (maxpos - minpos) * 0.05
		}
		if("market_price" in relevantData[0]){
			let priceArr = relevantData.map(x => x.market_price)
			let minprice = Math.min(...priceArr)
			let maxprice = Math.max(...priceArr)
			resizeCoord["yaxis3.range[0]"] = minprice - (maxprice - minprice) * 0.05
			resizeCoord["yaxis3.range[1]"] = maxprice + (maxprice - minprice) * 0.05
		}

		if(!self.graphElementExists()){//this should be debugged as this error should never actually appear
			return;
		}
		if(!this.state.graphIsLoaded){
			console.log("Graph not loaded and resizing should not be called")
			return;
		}
		Plotly.relayout(document.getElementById('graph'), resizeCoord)
	}

	loadGraph = (extend) => {
		let self = this;

		this.controller.abort();
		this.controller = new AbortController()

		self.setState({ graphIsLoading: true })

		function drawGraph(){
			let graphLines = [{
				name: "Net P&L",
				hovertemplate: '%{y:$,.0f}',
				y: self.timeseries.map(x => x.pnl),
				x: self.timeseries.map(x => x.timestamp),
				line: {
					color: (self.timeseries.length > 0 && self.timeseries[self.timeseries.length-1].pnl > 0 ? "#228B22" : "#8B0000")
				}
			}]

			if(self.state.sybl.length === 1){
				self.graphLayout.yaxis.domain = [0.45, 1]

				let graphLine2 = {
					yaxis: 'y2',
					x: (self.state.acct.length === 1 ? self.timeseriesPos : self.timeseries).map(x => x.timestamp),
					line: {
						dash: 'dashdot',
						color: "#964B00"
					}
				}

				let graphLayout2 = {
					domain: [0, 0.40],
					fixedrange: true,
					color: "#964B00"
				}

				if(self.state.posVSmv === "S"){
					graphLine2.y = (self.state.acct.length === 1 ? self.timeseriesPos.map(x => x.position) : self.timeseries.map(x => x.position))
					graphLine2.hovertemplate = '%{y:,.0f}'
					graphLine2.name = "Symbol Position"
					graphLayout2.title = "Symbol Position"
				}else if(self.state.posVSmv === "MV"){
					graphLine2.y = (self.state.acct.length === 1 ? self.timeseriesPos.map(x => x.position*x.price) : self.timeseries.map(x => x.position*x.market_price))
					graphLine2.hovertemplate = '%{y:$,.2f}'
					graphLine2.name = "Symbol MV"
					graphLayout2.title = "Symbol Market Value"
					graphLayout2.tickformat = '$,~s'
				}

				graphLines.push(graphLine2)
				self.graphLayout.yaxis2 = graphLayout2

				graphLines.push({
					name: "Symbol Price",
					hovertemplate: '%{y:$,.2f}',
					yaxis: 'y3',
					y: self.timeseries.map(x => x.market_price),
					x: self.timeseries.map(x => x.timestamp),
					line: {
						dash: 'dot',
						color: "#1874CD"
					}
				})

				self.graphLayout.yaxis3 = {
					title: "Symbol Price",
					fixedrange: true,
					overlaying: 'y2',
					side: 'right',
					color: "#1874CD",
					tickformat: '$,.2f'
				}
			}else{
				delete self.graphLayout.yaxis.domain
				delete self.graphLayout.yaxis2
				delete self.graphLayout.yaxis3
			}

			self.graphLayout.height = self.state.height

			if(!self.graphElementExists()){//this should be debugged as this error should never actually appear
				return;
			}
			Plotly.newPlot('graph', graphLines, self.graphLayout, self.graphConfig);
			self.setState({graphIsLoaded: true})
			self.resizeGraph()

			document.getElementById('graph').on('plotly_relayout', function(eventdata){
				if('relayedout' in eventdata){
					return;
				}

				let obj = {}
				if("xaxis.range[0]" in eventdata){
					if(eventdata["xaxis.range[0]"] < self.state.startTS){
						obj["selectedx0"] = null
					}else{
						obj["selectedx0"] = eventdata["xaxis.range[0]"]
					}
				}if("xaxis.range[1]" in eventdata){
					if(eventdata["xaxis.range[1]"] > self.state.endTS){
						obj["selectedx1"] = null
					}else{
						obj["selectedx1"] = eventdata["xaxis.range[1]"]
					}
				}if("xaxis.autorange" in eventdata){
					obj["selectedx0"] = null
					obj["selectedx1"] = null
				}
				if("selectedx0" in obj || "selectedx1" in obj){
					self.state.refilter(obj)
				}
				self.resizeGraph()
			});
			if(self.state.sybl.length === 1){
				document.getElementById('graph').on('plotly_hover', function (eventdata){
					Plotly.Fx.hover('graph', {xval: eventdata.xvals[0]}, ['xy', 'xy2', 'xy3']);
				});
			}
		}

		function GetExtensionSnapParam(){
			if(extend && self.timeseries.length > 0){
				let lastSnapTime = self.timeseries[self.timeseries.length - 1].timestamp.slice(11);
				return 'extendSnapStart='+lastSnapTime+'&'
			}
			return ''
		}

		function GetExtensionPosParam(){
			if(extend && self.state.acct.length === 1 && self.state.sybl.length === 1 && self.timeseriesPos.length > 0){
				let lastPosTime = self.timeseriesPos[self.timeseriesPos.length - 1].timestamp.slice(11);
				return 'extendPosStart='+lastPosTime+'&'
			}
			return ''
		}

		function setBoundaries(){
			self.setState({graphIsLoading: false}, function(){
				if(self.timeseries.length > 1){
					let smallestSSTS = self.timeseries[0].timestamp
					let largestSSTS = self.timeseries[self.timeseries.length - 1].timestamp
					let smallestTS = (self.timeseriesPos.length > 0 && self.timeseriesPos[0].timestamp < smallestSSTS ? self.timeseriesPos[0].timestamp : smallestSSTS)
					let largestTS = (self.timeseriesPos.length > 0 && self.timeseriesPos[self.timeseriesPos.length - 1].timestamp > largestSSTS ? self.timeseriesPos[self.timeseriesPos.length - 1].timestamp : largestSSTS)
					self.setState({
						startTS: smallestTS,
						endTS: largestTS
					}, function(){
						self.state.refilter({
							tsTimeS: smallestTS,
							tsTimeE: largestTS
						})
					})
				}
			})
		}

		const apiClient = createApiClient();
		apiClient.get(MWBaseURL()+'timeseries?'+GetExtensionSnapParam()+GetExtensionPosParam()+GetParams(this.state), {signal: this.controller.signal})
		.then(data => {
			if(data.length <= 0){
				console.log("No timeseries data")
				return;
			}

			if(!self.graphElementExists()){//this should be debugged as this error should never actually appear
				return;
			}
			if(extend){
				if(self.state.acct.length === 1 && self.state.sybl.length === 1){
					self.timeseries = self.timeseries.concat(data.snapshot)
					self.timeseriesPos = self.timeseriesPos.concat(data.positions)
					setBoundaries()
					let obj = {
						y: [data.snapshot.map(x => x.pnl), data.snapshot.map(x => x.market_price), (self.state.posVSmv === "S" ? data.positions.map(x => x.position) :  data.positions.map(x => x.position*x.price))],
						x: [data.snapshot.map(x => x.timestamp), data.snapshot.map(x => x.timestamp), data.positions.map(x => x.timestamp)]
					}
					Plotly.extendTraces('graph', obj, [0, 2, 1])
					Plotly.restyle('graph', {'line.color': 
						(self.timeseries.length > 0 && self.timeseries[self.timeseries.length-1].pnl > 0 ? "#228B22" : "#8B0000")
					}, [0])
				}else if(self.state.sybl.length === 1){
					self.timeseries = self.timeseries.concat(data.snapshot)
					setBoundaries()
					let obj = {
						y: [data.snapshot.map(x => x.pnl), data.snapshot.map(x => x.market_price), (self.state.posVSmv === "S" ? data.snapshot.map(x => x.position) :  data.snapshot.map(x => x.position*x.market_price))],
						x: [data.snapshot.map(x => x.timestamp), data.snapshot.map(x => x.timestamp), data.snapshot.map(x => x.timestamp)]
					}
					Plotly.extendTraces('graph', obj, [0, 2, 1])
					Plotly.restyle('graph', {'line.color': 
						(self.timeseries.length > 0 && self.timeseries[self.timeseries.length-1].pnl > 0 ? "#228B22" : "#8B0000")
					}, [0])
				}else{
					self.timeseries = self.timeseries.concat(data.snapshot)
					setBoundaries()
					let obj = {
						y: [data.snapshot.map(x => x.pnl)],
						x: [data.snapshot.map(x => x.timestamp)]
					}
					Plotly.extendTraces('graph', obj, [0])
					Plotly.restyle('graph', {'line.color': 
						(self.timeseries.length > 0 && self.timeseries[self.timeseries.length-1].pnl > 0 ? "#228B22" : "#8B0000")
					}, [0])
				}
				self.setState({graphIsLoaded: true})
				self.resizeGraph()
			}else{
				self.timeseries = data.snapshot
				self.timeseriesPos = data.positions
				setBoundaries()
				if(self.timeseries.length || self.timeseriesPos.length){
					drawGraph()
				}
			}

		}).catch(e => console.log(e.message));
	}

	graphElementExists = () => {
		if($('#graph').length === 0){//this should be debugged as this error should never actually appear
			console.log("Graph does not exist this component should not exist")
			return false;
		}
		return true;
	}

	handleGraphRangeReset = () => {
		Plotly.relayout(document.getElementById('graph'), {"xaxis.autorange": true})//will cause relayout to run
	}

	render(){
		return (
			<div style={{height: this.state.height+"px", position: "relative"}}>
				{this.state.graphIsLoading && 
					(<div id="loading" className="p-4" style={{position: "absolute", width: "100%", zIndex: "20", background: "grey", opacity: "0.2", height: this.state.height+"px"}}>
						<div className="dotwrapper" style={{opacity: "1"}}>
							<div className="dot0" />
							<div className="dot1" />
							<div className="dot2" />
						</div>
					</div>)
				}
				{(this.state.sybl.length === 1) && <div className="btn-group btn-group-toggle ml-2 mb-1" data-toggle="buttons">
					<div className="input-group-append">
						<span className="input-group-text">Position Display: </span>
					</div>
					<label className={"btn btn-secondary form-control"+(this.state.posVSmv === "S" ? " active" : "")}>
						<input readOnly type="radio" name="options" id="option1" autoComplete="off" value="S" checked={this.state.posVSmv === "S"} onClick={e => this.setState({posVSmv: e.target.value, needToUpdate: true})}/>Shares
					</label>
					<label className={"btn btn-secondary form-control"+(this.state.posVSmv === "MV" ? " active" : "")}>
						<input readOnly type="radio" name="options" id="option2" autoComplete="off" value="MV" checked={this.state.posVSmv === "MV"} onClick={e => this.setState({posVSmv: e.target.value, needToUpdate: true})}/>MV
					</label>
				</div>}
				{(this.state.start || this.state.end) && <button className="btn btn-secondary ml-3 mb-1" onClick={this.handleGraphRangeReset}>Jump to full-day</button>}
				<div id="graph"></div>
			</div>
		)
	}
}
export default Graph;